module.exports = __webpack_public_path__ + "media/images/lb/836-7560acc96b9819f1f8079cc8e000c015.svg";